/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dashboard-renderer.vue?vue&type=template&id=24e61a8e"
import script from "./dashboard-renderer.vue?vue&type=script&lang=js"
export * from "./dashboard-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports